<template>
  <div class="systemFunction-container">
    <div class="pc d-none d-lg-block">
      <p class="title">系统功能</p>
      <div class="container">
        <div class="left" data-aos="flip-up" :data-aos-duration="1 * 1000">
          <img src="~/assets/img/solution/irtc.png" alt="" />
          <p class="platform-text">iRTC智能实时音视频平台</p>
          <ul>
            <li>高清实时音视频交互</li>
            <li>全平台兼容</li>
            <li>屏幕共享</li>
            <li>安全录制</li>
            <li>VoLTE视频客服</li>
          </ul>
        </div>
        <div class="middle" data-aos="flip-up" :data-aos-duration="1 * 1000">
          <img src="~/assets/img/solution/ivcs.png" alt="" />
          <p class="platform-text">iVCS 智能视频远程服务平台</p>
          <ul>
            <li>智能视频RPA工作流平台</li>
            <li>同屏辅助</li>
            <li>结构化回溯</li>
            <li>视频打点</li>
            <li>表单推送</li>
            <li>地理位置、水印</li>
            <li>数字签名</li>
          </ul>
        </div>
        <div class="middle" data-aos="flip-up" :data-aos-duration="1 * 1000">
          <img src="~/assets/img/solution/ai.png" alt="" />
          <p class="platform-text">AI能力对接平台</p>
          <ul>
            <li>数字人</li>
            <li>OCR证件识别</li>
            <li>ASR语音识别</li>
            <li>TTS语音合成</li>
            <li>人脸、在框、活体检测</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="d-lg-none mobile">
      <p class="title">系统功能</p>
      <div class="mobile-container">
        <div class="top" data-aos="flip-up" :data-aos-duration="1 * 1000">
          <img src="~/assets/img/solution/irtc-mobile.png" alt="" />
          <p class="platform-text">iRTC智能实时音视频平台</p>
          <ul>
            <li>高清实时音视频交互</li>
            <li>全平台兼容</li>
            <li>屏幕共享</li>
            <li>安全录制</li>
            <li>VoLTE视频客服</li>
          </ul>
        </div>
        <div class="middle" data-aos="flip-up" :data-aos-duration="1 * 1000">
          <img src="~/assets/img/solution/ivcs-mobile.png" alt="" />
          <p class="platform-text">iVCS 智能视频远程服务平台</p>
          <ul>
            <li>智能视频RPA工作流平台</li>
            <li>同屏辅助</li>
            <li>结构化回溯</li>
            <li>视频打点</li>
            <li>表单推送</li>
            <li>地理位置、水印</li>
            <li>数字签名</li>
          </ul>
        </div>
        <div class="bottom" data-aos="flip-up" :data-aos-duration="1 * 1000">
          <img src="~/assets/img/solution/ai-mobile.png" alt="" />
          <p class="platform-text">AI能力对接平台</p>
          <ul>
            <li>数字人</li>
            <li>OCR证件识别</li>
            <li>ASR语音识别</li>
            <li>TTS语音合成</li>
            <li>人脸、在框、活体检测</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {};
</script>

<style lang="scss" scoped>
  .systemFunction-container {
    background-color: #e9f9f7;
    .pc {
      @import "./title.scss";
      .title {
        @extend %title;
        padding-top: 60px;
      }
      .container {
        margin: 0 auto;
        padding-top: 60px;
        padding-bottom: 64px;
        display: flex;
        img {
          width: 96px;
          height: 96px;
          margin: 22px 0 18px;
        }
        .platform-text {
          font-size: 22px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #333333;
        }
        ul {
          margin-top: 28px;
        }
        li {
          width: 302px;
          height: 35px;
          margin: 0 auto;
          background-color: #f7fafc;
          margin-top: 12px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #727374;
          line-height: 35px;
        }
        .left {
          width: 346px;
          height: 550px;
          border-radius: 24px;
          background-color: #fff;
          text-align: center;
        }
        .middle {
          width: 346px;
          height: 550px;
          border-radius: 24px;
          background-color: #fff;
          text-align: center;
          margin-left: 32px;
        }
      }
    }
    .mobile {
      @import "./mobileTitle.scss";
      .title {
        @extend %mobileTitle;
        padding-top: 40px;
      }
      .mobile-container {
        padding-bottom: 48px;
        img {
          width: 76px;
          height: 76px;
          margin: 22px 0 8px;
        }
        .platform-text {
          font-size: 18px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #333333;
        }
        ul {
          margin-top: 20px;
        }
        li {
          width: 275px;
          height: 35px;
          margin: 0 auto;
          background-color: #f7fafc;
          margin-top: 12px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #727374;
          line-height: 35px;
        }
        .top {
          width: 311px;
          height: 406px;
          border-radius: 24px;
          background-color: #fff;
          text-align: center;
          margin: 0 auto;
          margin-top: 27px;
        }
        .middle {
          width: 311px;
          height: 500px;
          border-radius: 24px;
          background-color: #fff;
          text-align: center;
          margin: 0 auto;
          margin-top: 30px;
        }
        .bottom {
          width: 311px;
          height: 406px;
          border-radius: 24px;
          background-color: #fff;
          text-align: center;
          margin: 0 auto;
          margin-top: 30px;
        }
      }
    }
  }
</style>
